var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/ui/datepicker/datepicker.tsx";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { useEffect, useMemo, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Select from '../select/select';
import Stack from '../stack/stack';
import Text from '../text/text';

const getDaysInMonth = (month, year) => new Date(year, month + 1, 0).getDate();

const currentYear = new Date().getFullYear();

/**
 * Datepicker that allows a user to select month, day, and year.
 */
const Datepicker = _ref => {
  let {
    onChange
  } = _ref;
  const intl = useIntl();
  const [month, setMonth] = useState(new Date().getMonth());
  const [day, setDay] = useState(new Date().getDate());
  const [year, setYear] = useState(2022);
  const numberOfDays = useMemo(() => {
    return getDaysInMonth(month, year);
  }, [month, year]);
  useEffect(() => {
    onChange(new Date(year, month, day));
  }, [month, day, year]);
  return /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 gap-y-2 gap-x-2 sm:grid-cols-3",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "sm:col-span-1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Text, {
    size: "sm",
    weight: "medium",
    theme: "muted",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "datepicker.month",
    defaultMessage: "Month",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement(Select, {
    value: month,
    onChange: event => setMonth(Number(event.target.value)),
    "data-testid": "datepicker-month",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 11
    }
  }, [...Array(12)].map((_, idx) => /*#__PURE__*/React.createElement("option", {
    key: idx,
    value: idx,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 15
    }
  }, intl.formatDate(new Date(year, idx, 1), {
    month: 'long'
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "sm:col-span-1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Text, {
    size: "sm",
    weight: "medium",
    theme: "muted",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "datepicker.day",
    defaultMessage: "Day",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement(Select, {
    value: day,
    onChange: event => setDay(Number(event.target.value)),
    "data-testid": "datepicker-day",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 11
    }
  }, [...Array(numberOfDays)].map((_, idx) => /*#__PURE__*/React.createElement("option", {
    key: idx,
    value: idx + 1,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 15
    }
  }, idx + 1))))), /*#__PURE__*/React.createElement("div", {
    className: "sm:col-span-1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 73,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 74,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Text, {
    size: "sm",
    weight: "medium",
    theme: "muted",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 75,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "datepicker.year",
    defaultMessage: "Year",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement(Select, {
    value: year,
    onChange: event => setYear(Number(event.target.value)),
    "data-testid": "datepicker-year",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 79,
      columnNumber: 11
    }
  }, [...Array(121)].map((_, idx) => /*#__PURE__*/React.createElement("option", {
    key: idx,
    value: currentYear - idx,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85,
      columnNumber: 15
    }
  }, currentYear - idx))))));
};

export default Datepicker;